import { t } from 'i18next';
import { z } from 'zod';
import { OnboardingFormFields } from '@Types/index';
import { typedObjectValues } from 'src/utils';
import type { OwnersCenterFormType } from './OwnersCenterForm.types';

const uboPercentageField = () =>
  z
    .number({
      error: t('enErrors:required'),
    })
    .min(25, t('enErrors:ownerCenter.ownershipPercentageTooLow'))
    .max(100)
    .optional();

export const ownersCenterScheme = z
  .object({
    [OnboardingFormFields.OWNER_PERCENTAGE]: z
      .number({
        error: t('enErrors:required'),
      })
      .max(100)
      .min(0),
    [OnboardingFormFields.OWNER_CENTER_CONSENT]: z.literal(true),
    [OnboardingFormFields.OWNER_CENTER_UBO_1_PERCENTAGE]: uboPercentageField(),
    [OnboardingFormFields.OWNER_CENTER_UBO_2_PERCENTAGE]: uboPercentageField(),
    [OnboardingFormFields.OWNER_CENTER_UBO_3_PERCENTAGE]: uboPercentageField(),
    [OnboardingFormFields.OWNER_CENTER_UBO_4_PERCENTAGE]: uboPercentageField(),
  })
  .superRefine((data, ctx) => {
    const total = Object.values(data).reduce<number>(
      (acc, curr) => (typeof curr === 'number' ? acc + curr : acc),
      0
    );
    if (total > 100) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t('enErrors:ownerCenter.ownershipPercentageTooHigh'),
      });
    }
  });

export const calculateOverallPercentage = (data: OwnersCenterFormType) => {
  return typedObjectValues(data).reduce<number>((acc, curr) => {
    if (typeof curr === 'number') {
      return acc + curr;
    }
    return acc;
  }, 0);
};
